module.exports = __webpack_public_path__ + "img/img_13.5a98165e.png";